export default "__VITE_ASSET__D8hT2F0t__"